import { get, isEmpty, size } from 'lodash/fp';
import React from 'react';

import CalloutSection from '../../../../components/sections/callout-section';
import FeaturesSection from '../../../../components/sections/features-section';

const ValuePropositions = ({ ...props }) => {
  const tiles = get('tiles', props);
  if (isEmpty(tiles)) {
    return null;
  }

  if (size(tiles) > 1) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    return <FeaturesSection {...props} withBorder />;
  }

  return <CalloutSection {...tiles[0]} withBorder />;
};

export default ValuePropositions;
